/** The most useful message from an API error: the first field error, else the server message. */
export const apiMessage = (error: unknown, fallback: string): string => {
  const data = (error as { response?: { data?: { message?: string; errors?: Record<string, string[] | string> } } })?.response?.data;
  const errors = data?.errors;
  if (errors) {
    const first = Object.entries(errors).find(([k]) => k !== "code")?.[1];
    if (first) return Array.isArray(first) ? first[0] : first;
  }
  return data?.message || fallback;
};

/** Field-level errors from a 422 response, keyed by field. */
export const fieldErrors = (error: unknown): Record<string, string> => {
  const errors = (error as { response?: { data?: { errors?: Record<string, string[] | string> } } })?.response?.data?.errors ?? {};
  return Object.fromEntries(Object.entries(errors).filter(([k]) => k !== "code").map(([k, v]) => [k, Array.isArray(v) ? v[0] : v]));
};

export const money = (amount: string | number | null | undefined, currency?: string | null) => {
  if (amount === null || amount === undefined || amount === "") return "—";
  const n = Number(amount);
  if (!Number.isFinite(n)) return String(amount);
  return `${currency ?? ""} ${n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`.trim();
};

export const label = (v: string | null | undefined) => (v ? v.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase()) : "—");

export const shortDate = (v: string | null | undefined) => (v ? new Date(v.length === 10 ? `${v}T00:00:00` : v).toLocaleDateString() : "—");
